const cart = {
    title: 'Your Cart',
    subtitle: 'Review your selected products',
    errorLoading: 'Error loading cart',
    errorUpdating: 'Error updating quantity',
    errorRemoving: 'Error removing product',
    errorClearing: 'Error clearing cart',
    confirmClear: 'Are you sure you want to empty the cart?',
    emptyCart: 'Your cart is empty',
    checkoutError: 'Error during checkout',
    items: 'items',
    clearCart: 'Clear cart',
    emptyTitle: 'Empty Cart',
    emptySubtitle: 'Add some products to get started',
    browseProducts: 'Browse Products',
    orderSummary: 'Order Summary',
    productsSummary: 'Products',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    freeShipping: 'Free',
    total: 'Total',
    proceedToCheckout: 'Proceed to Checkout',
    processing: 'Processing...',
    secureCheckout: 'Secure Checkout',
    shippingInfo: 'Shipping Information',
    selectShipping: 'Select Shipping',
    shippingAddress: 'Shipping Address',
    useProfileAddress: 'Use profile address',
    editShippingAddress: 'Edit',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    saveAddress: 'Save Address',
    hide: 'Hide',
    addShippingAddress: 'Add Shipping Address',
    shippingNotAvailable: 'Shipping Not Available',
    shippingNotAvailableMessage: 'We cannot ship to the selected address. Choose another address or contact us for assistance.',
    availableCountries: 'Countries available for shipping:'
};

export default cart;
